{
    "Profile_Terms.terms": "FR: Terms",
    "Profile_Terms.term": "FR: Term: {term}",
    "Profile_Terms.policyNumber": "FR: Policy Number: {number}",
    "Profile_Terms.transactionType": "FR: Transaction Type",
    "Profile_Terms.effectiveDate": "FR: Effective Date",
    "Profile_Terms.expiryDate": "FR: Expiry Date",
    "Profile_Terms.premium": "FR: Premium",
    "Profile_Terms.taxes": "FR: Taxes",
    "Profile_Terms.fees": "FR: Fees",
    "Profile_Terms.total": "FR: Total",
    "Profile_Terms.status": "FR: Status",
    "Profile_Terms.totalLabel": "FR: Total:"
}
